<template lang="pug">
    v-autocomplete(dense 
        v-model="dataRole" 
        :disabled="disabled"
        :readonly="readonly" 
        :label="label" 
        :rules="rules"
        :items="listData" 
        item-text="description" 
        item-value="id" 
        @change="onSelect" 
        :required = "required")
</template>
<script>
export default {
    name: "FSelectRole",
    props: [
        "value",
        "disabled",
        "readonly",
        "label",
        "rules",
        "required",
        "isAdmin",
        "needVerification"
    ],
    data() {
        return {
            dataRole: {},
            listData: []
        }
    },
    mounted() {
        if (this.isAdmin) {
            this.getRoleAdmin();
        }else{
            this.getRoleUser();
        }
        this.doInit(this.value);
    },
    watch: {
        value(val){
            this.doInit(val);
        }
    },
    methods: {
        doInit(values){
            this.dataRole = values ? values : null;
        },
        getRoleAdmin(){
            this.$http.get("/api/parameter/admin-role").then(success => {
                this.listData = success.data;
            });
        },
        getRoleUser(){
            this.$http.get("/api/parameter/user-role").then(success => {
                this.listData = success.data;
                if (!this.needVerification) {
                    this.listData = this.listData.filter(f => f.id != 'VRF_USER');
                }
            });
        },
        onSelect() {
            this.$emit("input", this.dataRole);
            this.$emit("select", this.dataRole);
            this.$emit("role", this.valueData());
        },
        valueData(){
            let result = null;
            this.listData.map(element => {
                if (this.dataRole === element.id) {
                    result = element;
                }
            });
            return result;
        },
    },
}
</script>